<template>
  <section class="climate-page">
    <div class="container-fluid d-none d-sm-block" style="height: 510px; background: url('/assets/img/climate-finance-composition2.jpg') top / cover no-repeat;">
        <div class="row" style="height: 500px;">
           <div class="col col-xl-5 offset-xl-0">
             <div class="text-hover-wrap">
              <div class="pb-0 d-flex justify-content-center me-0 climate-title" style="font-family:'Nortune', sans-serif;font-weight:700;font-size:40px;text-align:center;">
                  <span style="color: #1E4C34;">CLIMATE</span>
              </div>
              <div class="pb-0 d-flex justify-content-center me-0 climate-subtitle" style="font-family:'Nortune', sans-serif;font-weight:700;font-size:30px;text-align:center;">
               <span class="d-flex justify-content-center align-items-start" style="color: #338747;font-size: 40px;font-family:
                 'Raleway', sans-serif;margin-top: -20px;">Finance Faculty</span>
              </div>
            </div>
                
           </div>


        </div>
</div>

    <!-- Redesigned tiles section -->
    <div class="d-none d-sm-block climate-tiles">
      <div class="px-0 container-fluid climate-tiles__inner">
        <div class="row g-0">
          <div class="p-0 col-12 col-md-6 col-xl-4">
            <div class="climate-tile" role="img" aria-label="Climate Finance">
              <div class="climate-tile__media">
                <img
                  class="climate-tile__img"
                  src="/assets/img/CLIMATE-FINANCE-SECTION.jpg"
                  alt="Climate finance"
                />
              </div>
            </div>
          </div>

          <div class="p-0 col-12 col-md-6 col-xl-4" style="margin-top: -160px;">
            <router-link
              class="climate-tile climate-tile--tall climate-tile--clickable"
              style="display: block"
              :to="{ name: 'climate-community-sustainability' }"
              aria-label="Community Sustainability"
            >
              <div class="climate-tile__media">
                <img
                  class="climate-tile__img"
                  src="/assets/img/community-sustainability.jpg"
                  alt="Community sustainability"
                />
              </div>
            </router-link>
          </div>

          <div class="p-0 col-12 col-md-6 col-xl-4">
            <div class="climate-tile climate-tile--clickable" role="button" tabindex="0" aria-label="Climate Change Action">
              <div class="climate-tile__media">
                <img
                  class="climate-tile__img"
                  src="/assets/img/climate-change-action.jpg"
                  alt="Climate change action"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
       <div class="container-fluid d-none d-sm-block" style="height: 510px; background: url('/assets/img/75.jpg') top / cover no-repeat;">
        <div class="row" style="height: 500px;">
            <div class="col" style="justify-content: center; align-items: center; display: flex; border-style: none; text-align: right;padding-left: 120px;">
                <div class="text-hover-wrap">
                    <h5 class="text-center" style="color: rgb(0, 0, 0); ">
                <span style="color: #000000; font-family:nortune;font-size:50px;">Land</span>
                <span style="color: #000000; font-size:40px;">Use &</span>
                <span style="color: #000000; font-family:nortune;font-size:50px;">Environment</span>
                <span style="color: #000000; font-size:40px;">Protection</span>
                   </h5>
                </div>

            </div>


        </div>
</div>

    <div class="d-none d-sm-block climate-tiles">
      <div class="px-0 container-fluid climate-tiles__inner">
        <div class="row g-0">
          
          <div class="p-0 col-12 col-md-6 col-xl-4" style="margin-top: -160px;">
            <div class="climate-tile climate-tile--tall" role="img" aria-label="Community Sustainability">
              <div class="climate-tile__media">
                <img
                  class="climate-tile__img"
                  src="/assets/img/ss.jpg"
                  alt="Community sustainability"
                />
              </div>
            </div>
          </div>

          <div class="p-0 col-12 col-md-6 col-xl-4">
            <div class="climate-tile" role="img" aria-label="Climate Finance">
              <div class="climate-tile__media">
                <img
                  class="climate-tile__img"
                  src="/assets/img/Renewable-Energy.jpg"
                  alt="Climate finance"
                />
              </div>
            </div>
          </div>



          <div class="p-0 col-12 col-md-6 col-xl-4" style="margin-top: -160px;">
            <div class="climate-tile climate-tile--tall" role="img" aria-label="Community Sustainability">
              <div class="climate-tile__media">
                <img
                  class="climate-tile__img"
                  src="/assets/img/foodsecurity.jpg"
                  alt="Community sustainability"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'ClimatePage'
}
</script>

<style scoped>
.climate-page {
  width: 100%;
}

.text-hover-wrap {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

/* Tiles section */
.climate-tiles {
  background: #961936;
}

.climate-tiles__inner {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.climate-tile {
  position: relative;
  overflow: visible;
  border-radius: 0;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.35);
  transform: translateY(0);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  background: rgba(255, 255, 255, 0.08);
  z-index: 0;
}

/* White pop-out card behind the tile */
.climate-tile::before {
  content: '';
  position: absolute;
  inset: -12px;
  background: transparent;
  opacity: 0;
  transform: translateY(10px) scale(0.98);
  transition: opacity 0.22s ease, transform 0.22s ease;
  pointer-events: none;
}

.climate-tile__media {
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.climate-tile__img {
  width: 100%;
  height: 360px;
  object-fit: cover;
  display: block;
  transform: scale(1);
  transition: transform 0.35s ease;
}

/* Make the middle tile taller */
.climate-tile--tall .climate-tile__img {
  height: 520px;
}

.climate-tile:hover {
  transform: translateY(-10px) scale(1.01);
  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.55);
  z-index: 5;
}

.climate-tile:hover::before {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.climate-tile:hover .climate-tile__img {
  transform: scale(1.04);
}

.climate-tile--clickable {
  cursor: pointer;
}

.climate-tile--clickable:focus {
  outline: none;
}

.climate-tile--clickable:focus-visible {
  box-shadow: 0 0 0 3px rgba(252, 238, 5, 0.85), 0 22px 46px rgba(0, 0, 0, 0.45);
}

/* Keyboard users should get the same pop-out affordance */
.climate-tile--clickable:focus-visible::before {
  opacity: 1;
  transform: translateY(0) scale(1);
}

@media (max-width: 575.98px) {
  .climate-tile__img {
    height: 280px;
  }

  .climate-tile--tall .climate-tile__img {
    height: 280px;
  }
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .climate-tile--tall .climate-tile__img {
    height: 360px;
  }
}
</style>
